import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {PlayArrow} from "@mui/icons-material";
import {Button, IconButton} from "@material-ui/core";
import TruncatedDisplay from "../../../../util/common/TruncatedDisplay";
import HelpInfoButton from "./HelpInfoButton";
import {OpenArrow} from "../../../../../helpers/Icons";

const styles = {
  root:{
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  title:{
    display: "flex",
    flexWrap: "wrap",
    gap: "0.25rem 0.5rem",
    padding: "0.25rem 0 0.25rem 0.5rem",
    backgroundColor: "rgba(0, 62, 88, 0.025)",
    border: "1px solid #ddd",
    borderWidth: "0 0 1px 0",
    alignItems: "start",
    cursor: 'pointer',
    transition: 'background-color 0.1s',
    '&:hover': {
      backgroundColor: "rgba(0, 62, 88, 0.05)",
    },
  },
  header:{
    display: "flex",
    flexWrap: "wrap",
    gap: "0.25rem 0.5rem",
    alignItems: "center",
    minHeight: "30.75px",
  },
  content:{
  },
  label:{
    fontSize: "1rem",
    fontWeight: "600",
    opacity: "0.87",
  },
  subtitle:{
    fontSize: "0.85em",
    fontWeight: "400",
  },
  count: {
  },
  status: {
  },
  description:{
    fontSize: "0.85rem",
    fontWeight: "300",
    flex: 1,
    minWidth: "calc(min(100%, 25rem))",
    whiteSpace: "pre-wrap",
  },
  completed: {
    backgroundColor: "rgb(133, 238, 59, 0.5)",
    '&:hover': {
      backgroundColor: "rgb(133, 238, 59, 0.75)",
    },
  },
  started: {
    backgroundColor: "rgba(255, 249, 84, 0.5)",
    '&:hover': {
      backgroundColor: "rgba(255, 249, 84, 0.75)",
    },
  },
  openClose: {
    transition: "transform 300ms !important",
  },
  open: {
    transform: "rotate(90deg)",
  },
  closed: {
  }
};

function SurveyGroupStatus(props) {
  const { helpIndex, surveyGroup, startSurvey, openDataView, open, setOpen, completed, groupCount, groupStatus, isRoot, rootNext, classes } = props;

  const nextSurvey = surveyGroup.info?.next
  const nextButton = !nextSurvey ? null : ((!nextSurvey.attempts ? "Start Next" : "Resume") + `: ${nextSurvey.name}`)
  const nextButtonColor = !nextSurvey ? "primary" : (!nextSurvey.attempts ? "primary" : "secondary")
  const hasNext = !!nextSurvey && (isRoot || !rootNext || surveyGroup?.info?.next?.id !== rootNext);


  return (
    <div id={"groupInfo"} className={classes.root}>
      <div
        className={`${classes.title} ${groupStatus === 2 ? classes.completed : groupStatus > 0 ? classes.started : ""}`}
        onClick={() => setOpen(!open)}
      >
        {/*<div className={classes.icon}>*/}
        {/*  <Quiz/>*/}
        {/*</div>*/}
        <div className={classes.header}>
          <div>
            <IconButton size={"small"}>
              <OpenArrow className={`${classes.openClose} ${open ? classes.open : classes.closed}`}/>
            </IconButton>
          </div>
          <div className={classes.label}>
            <span id="groupName">{surveyGroup.name}</span>
            <HelpInfoButton helpIndex={helpIndex} />
          </div>
          <div className={classes.count}>
            (<span id="groupCompleted">{completed}</span> / <span id="groupTotal">{groupCount}</span>)
          </div>
          <div id="groupStatus" className={classes.status}>
            {groupStatus === 0 ? "Not Started"
              : groupStatus === 1 ? "In Progress"
              : "Completed"
            }
          </div>
          {!hasNext ? null :
            <div>
              <Button
                id="surveyNext"
                className={classes.start}
                variant="contained"
                // color={!nextSurvey.attempts ? "primary" : "secondary"}
                color={nextButtonColor}
                size={isRoot ? "medium" : "small"}
                endIcon={<PlayArrow/>}
                // onClick={(e) => startSurvey(nextSurvey.id, survey => openDataView?.(survey.mindfile_item.id))}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(!nextSurvey.attempts) {
                    startSurvey(nextSurvey.id, survey => openDataView?.(survey.mindfile_item.id))
                  }else {
                    openDataView(nextSurvey.attempts?.item_id)
                  }
                }}
              >{nextButton}</Button>
            </div>
          }
        </div>
        <div className={classes.description}>
          <TruncatedDisplay id="groupDescription" open={open} rows={2} onClick={()=>{}}>
            {surveyGroup.description || ""}
          </TruncatedDisplay>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(SurveyGroupStatus);
